import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { useScrollLock } from "../../../hooks/useScrollLock";
import { useEffect } from "react";
import { closeAllModal, showModal, showNestedModal } from "../../../features/modal/modalSlice";
import { handleActiveSelect } from "../../../features/layout/layoutSlice";
import SelectLoadMap from "../../map/SelectLoadMap";
import Button from "../../shared/Button";
import { setUpdateRouteMap } from "../../../features/addLoad/addLoadSlice";

const Container = styled.div`
 position: fixed;
   top: 0;
   right: 0;
   bottom: 0;
   left: 0;
   background-color: rgba(0,0,0,0.6);
   display: flex;
   justify-content: center;
   align-items: center;
   z-index: 100;

  .modal {
    width: 600px;
    height: auto;
    color: ${({ theme }) => theme.mainTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
    padding: 20px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .content {
      width: 100%;
      height: 100%;
      h3{
        text-align: center;
        margin-bottom: 20px;

      }
      .buttons{
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 15px;
      }
    }
  }
`;

const MapChangesModal = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  
  const { defaultRouteState,route } = useSelector((state) => state.addLoad);
  const { modalLocation } = useSelector((state) => state.modal);
  const { lockScroll, unlockScroll } = useScrollLock();

  //! bu modal açıldığnda ekran ı lock lamak için
  useEffect(() => {
    lockScroll();

    return () => {
      unlockScroll();
    };
  }, [lockScroll, unlockScroll]);

  //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
  useEffect(() => {
    if (location.pathname !== modalLocation) {
      dispatch(showModal(null));
    }
  }, [dispatch, location.pathname, modalLocation]);


  const handleDelete =()=>{
    dispatch(setUpdateRouteMap(defaultRouteState))
    dispatch(closeAllModal(null))
  }

  const handleSave=()=>{
    dispatch(closeAllModal(null))
    dispatch(setUpdateRouteMap(route))
  }

  return (
    <Container onClick={()=> dispatch(showNestedModal(null))}>
      <div
        className="modal"
        onClick={(e) => {
          e.stopPropagation();
          dispatch(handleActiveSelect(null));
        }}
      >
        <div className="content">
          <h3>Değişiklikleri İptal Etmek İstediğinize Emin Misiniz?</h3>
          <div className="buttons">
            <Button handleClick={handleSave} color={"#F4F4F4"} background={"#E85446"} width="100%" radius={"10px"} text={"Kaydet"} fontSize="14px"/>
            <Button handleClick={handleDelete} color={"#F4F4F4"} background={"#E85446"} width="100%" radius={"10px"} text={"İptal Et"} fontSize="14px"/>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default MapChangesModal;

